import {
  Form as VeeForm,
  Field as VeeField,
  defineRule,
  ErrorMessage,
  configure,
} from 'vee-validate';
import {
  required,
  min,
  max,
  alpha_spaces as alphaSpaces,
  email,
  min_value as minValue,
  max_value as maxValue,
  confirmed,
  not_one_of as excluded,
} from '@vee-validate/rules';

export default {
  install(app) {
    app.component('VeeForm', VeeForm);
    app.component('VeeField', VeeField);
    app.component('ErrorMessage', ErrorMessage);

    defineRule('required', required);
    defineRule('tos', required);
    defineRule('title', required);
    defineRule('min', min);
    defineRule('min_title', min);
    defineRule('max', max);
    defineRule('max_title', max);
    defineRule('alpha_spaces', alphaSpaces);
    defineRule('email', email);
    defineRule('min_value', minValue);
    defineRule('max_value', maxValue);
    defineRule('passwords_mismatch', confirmed);
    defineRule('excluded', excluded);
    defineRule('country_excluded', excluded);

    configure({
      generateMessage: (ctx) => {
        const messages = {
          required: `The ${ctx.field} field is required!`,
          min: `The ${ctx.field} field is too short!`,
          max: `The ${ctx.field} field is too long!`,
          alpha_spaces: `The ${ctx.field} field can contain alphabetic characters and spaces!`,
          email: `The ${ctx.field} field must be a valid email!`,
          min_value: `The ${ctx.field} is too low!`,
          max_value: `The ${ctx.field} is too high!`,
          excluded: `You are not allowed to use this value for the field ${ctx.field}!`,
          country_excluded: 'Sorry!! We don\'t accept users from this location.',
          passwords_mismatch: 'The passwords don\'t match!',
          tos: 'You must accept the Terms of Service!',
          title: 'Please provide a song title!',
          min_title: 'Provide a valid song name!',
          max_title: 'Song title can\'t be more than 50 characters long!',
        };

        const message = messages[ctx.rule.name]
          ? messages[ctx.rule.name]
          : `The Field ${ctx.field} is invalid!`;

        return message;
      },
      validateOnBlur: true,
      validateOnChange: true,
      validateOnInput: false,
      validateOnModelUpdate: true,
    });
  },
};
